import React from 'react';
import './RankingInt.css';

function RankingInt(props) {
	const { data, myorg } = props;
	if (!data?.length) {
		return null;
	}
	return (
		<div className="leaderboard-table">
			{data?.map((data,index)=>{
				return(
					<div className={'table-column ' + (myorg === data?.orgName ? 'self' : '')} key={index}>
						<div className="table-number">{data?.rank}</div>
						<div className="table-name">{data?.orgName}</div>
						<div className="table-point">{data?.points}</div>
					</div>
				)
			})}
		</div>
	);
}

export default RankingInt;
